import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{class:{
    'px-6': _vm.$vuetify.breakpoint.smAndUp,
    'px-0': _vm.$vuetify.breakpoint.mdAndUp,
  },staticStyle:{"max-width":"1160px"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }